import type { TeamRole } from '@store/reducers/dashboard/types'

export const DisabledRoles: TeamRole[] = ['ADMIN', 'MANAGER']

export const RoleOrder: Record<TeamRole, number> = {
  ADMIN: 2,
  MANAGER: 1,
  MEMBER: 0,
}
